import PropTypes from "prop-types";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthLayout from "../components/Layout/authLayout";
import AuthLayoutV2 from "../v2/app/AuthLayoutV2";
import { getUser } from "../utils/common";
import { usePermissionsFromJWT } from "../utils/DecodeJwt";

export default function RequireAuth({ children, requiredPermission, requiredAnyOf, useV2Layout = false }) {
  const location = useLocation();
  const user = getUser();
  const { permissions } = usePermissionsFromJWT();
  const Layout = useV2Layout ? AuthLayoutV2 : AuthLayout;
  const allowedPaths = ["/welcome", "/profile"];
  const hasRule = Boolean(requiredPermission) || (Array.isArray(requiredAnyOf) && requiredAnyOf.length > 0);

  if (!user || !permissions) {
    return <Navigate to="/login" replace state={{ path: location.pathname }} />;
  }

  if (!hasRule && !allowedPaths.includes(location.pathname)) {
    return <Layout unauthorized={true}>{children}</Layout>;
  }
  if (allowedPaths.includes(location.pathname)) {
    return <Layout>{children}</Layout>;
  }

  let hasPermission = false;
  if (Array.isArray(requiredAnyOf) && requiredAnyOf.length > 0) {
    hasPermission = requiredAnyOf.some((p) => permissions.includes(p));
  } else if (requiredPermission) {
    hasPermission = permissions.includes(requiredPermission);
  }

  return <Layout unauthorized={!hasPermission}>{hasPermission ? children : null}</Layout>;
}

RequireAuth.propTypes = {
  children: PropTypes.node.isRequired,
  requiredPermission: PropTypes.string,
  requiredAnyOf: PropTypes.arrayOf(PropTypes.string),
  useV2Layout: PropTypes.bool,
};
